import { render, staticRenderFns } from "./NotificationDetailDialog.vue?vue&type=template&id=5dca4b15&"
import script from "./NotificationDetailDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports